import DailyCounter from './DailyCounter'

const DailyVacuum = () => (
    <DailyCounter counterType='vacuum'/>
)

export default DailyVacuum
